import BannerBlock from './BannerBlock.vue'
import Carousel from './Carousel.vue'
import Grid from './Grid.vue'
import FAQ from './FAQ.vue'
import Testimonial from './Testimonial.vue'
import LinksBlock from './LinksBlock.vue'
import Pricing from './Pricing.vue'
import Text from './Text.vue'
import CardsSection from './CardsSection.vue'
import Events from './Events.vue'

export const blocksMap = {
  ComponentSharedBanner: BannerBlock,
  ComponentSharedCarousel: Carousel,
  ComponentSharedGrid: Grid,
  ComponentSharedFaqSection: FAQ,
  ComponentSharedReviews: Testimonial,
  ComponentSharedPricing: Pricing,
  ComponentSharedText: Text,
  ComponentSharedEventsList: Events,
  ComponentFooterFooterBlock: LinksBlock,
  ComponentCardsSection: CardsSection,
}
